import { useEffect } from 'react'
import { api } from '@/store/api'
import { useAppDispatch } from '@/store/hooks'
import type { StartFailure } from '@/features/ai/lib/parseStartError'

/**
 * §7: `422 unknown_image_targets` почти всегда значит «сущность удалили в
 * соседней вкладке, пока диалог был открыт». Ключи целей собирались по кешу —
 * раз бэк их не опознал, кеш устарел.
 *
 * Инвалидируем ОБА источника ключей, а не один: блоки дают цели блоков и
 * элементов дизайна, а баннер, маскоты, уроки и сам СПИСОК уроков живут в
 * детали курса. Без её перечитывания неопознанный маскот или удалённый урок
 * оставался бы в списке навсегда, повторный старт упирался бы в тот же отказ,
 * и выхода, кроме перезагрузки страницы, у автора не было бы.
 *
 * Сам текст отказа менять не надо — `imageFailureText` печатает серверный
 * список ключей как есть.
 */
export const useRefreshTargets = (failure: StartFailure | null, courseId: number): void => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (failure?.kind === 'business' && failure.code === 'unknown_image_targets') {
      dispatch(api.util.invalidateTags(['Block', { type: 'Course', id: courseId }]))
    }
  }, [failure, courseId, dispatch])
}
